var patch = require("./vdom/patch.js")

module.exports = patch



//////////////////
// WEBPACK FOOTER
// ./~/virtual-dom/patch.js
// module id = 183
// module chunks = 0